import React from 'react';
import Layout from '../../../app/Layout';
import HeaderComponent from '../General/HeaderContent';
import Breadcrumb from '../General/Breadcrumb';
import './scss/usuarios.scss'
import FormularioUsuario from './FormularioUsuario';
import { avisoCorrecto, avisoError } from '../../components/AvisosMensajes/MensajesSwalf';
import { useHistory } from 'react-router-dom';

//Redux
import { connect, useDispatch } from 'react-redux'
import { insertarNuevoUsuario, verificarDniExistente, agregarRolAUsuario } from '../../../actions/userActions'

const NuevoUsuario = (props) => {

    const { insertarNuevoUsuario } = props
    const history = useHistory()
    const dispatch = useDispatch()

    // areasAdicionales: roles adicionales (desde índice 1) pasados desde FormularioUsuario
    const nuevoUsuario = async (dataNuevoUsuario, areasAdicionales = []) => {
        const { mensaje, textMensaje } = await insertarNuevoUsuario(dataNuevoUsuario)

        if (mensaje) {
            // Si seleccionó más de un área, agregar roles adicionales
            if (areasAdicionales.length > 0) {
                const dniVerif = await dispatch(verificarDniExistente(String(dataNuevoUsuario.dni)))
                if (dniVerif && dniVerif.existe) {
                    for (const rolId of areasAdicionales) {
                        await dispatch(agregarRolAUsuario(dniVerif.id_usuario, parseInt(rolId)))
                    }
                }
            }
            avisoCorrecto(textMensaje)
            history.push('/trabajadores')
            return
        }
        avisoError(textMensaje)
    }

    return (
        <Layout>
            <HeaderComponent
                title='Nuevo trabajador'
                icon='person_add'
            />
            <Breadcrumb
              link={[
                {url:'/inicio', nombre: 'Inicio', icon: 'fas fa-home'},
                {url:'/trabajadores', nombre: 'Trabajadores'},
                {url:'', nombre: 'Nuevo trabajador'}
              ]}
            />

            <div className="content_new_usuario">
                <FormularioUsuario
                    nuevoUsuario={nuevoUsuario}
                />
            </div>
        </Layout>
     );
}

const mapStateToProps = state => ({})

const mapDispachtToProps = {
    insertarNuevoUsuario
}

export default connect(mapStateToProps, mapDispachtToProps)(NuevoUsuario);
